export interface ISetting {
  key: string;
  value: string;
}

export interface ISettingApiModel {
  key: string;
  value: string;
}

export default class Setting implements ISetting {
  public readonly key: string;

  public readonly value: string;

  constructor(key: string, value: string) {
    this.key = key;
    this.value = value;
  }

  static fromApiModel(apiModel: ISettingApiModel) {
    const { key, value } = apiModel;

    return new Setting(key, value);
  }

  static arrayFromApiModel(arrayApiModel: ISettingApiModel[]) {
    const array = arrayApiModel.map(apiModel => Setting.fromApiModel(apiModel));

    return array;
  }
}
